{
    "step_of": "الخطوة {{current}} من {{total}}",
    "next": "التالي",
    "back": "السابق",
    "skip": "تخطَّ الجولة",
    "finish": "ابدأ الاستخدام",
    "replay": "خُذ الجولة",
    "close": "أغلق الجولة"
}
